import { createElementBlock as c, openBlock as t, createElementVNode as l } from "vue";
import o from "./index289.js";
const n = {}, r = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function a(i, e, s, f, p, d) {
  return t(), c("svg", r, e[0] || (e[0] = [
    l("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      l("path", {
        fill: "#FFF9D5",
        d: "m36.149 23.889-7.855-9.31C28.905 9.198 33.474 5 39.086 5c0 5.953 4.887 10.78 10.914 10.78 0 3.604-1.81 6.777-4.562 8.732l-9.29-.623Z"
      }),
      l("path", {
        fill: "#F5F2E8",
        d: "M39.515 22.937c-1.242 0-2.412.256-3.435.769-.767-5.061-5.152-8.95-10.415-8.95-5.738 0-10.415 4.621-10.562 10.343C11.668 25.539 9 28.472 9 32.104c-.002 3.889 3.14 7.042 7.014 7.042h23.499c4.457 0 8.075-3.63 8.075-8.106.003-4.473-3.615-8.103-8.073-8.103Z"
      }),
      l("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "M39.086 3.75c.69 0 1.25.56 1.25 1.25 0 5.26 4.324 9.53 9.664 9.53.69 0 1.25.559 1.25 1.25 0 3.675-1.696 7.067-4.527 9.329a9.318 9.318 0 0 1 2.115 5.931c0 5.165-4.176 9.356-9.325 9.356H16.014c-4.566 0-8.267-3.715-8.264-8.292 0-3.777 2.48-6.982 5.947-7.986l.225-.062.02-.176c.724-5.751 5.555-10.223 11.424-10.37l.299-.004c.512 0 1.017.033 1.513.097C28.222 7.952 33.18 3.75 39.086 3.75ZM25.665 16.006c-5.044 0-9.183 4.064-9.313 9.125a1.25 1.25 0 0 1-1.09 1.208c-2.857.366-5.012 2.808-5.012 5.766-.002 3.198 2.581 5.791 5.764 5.791h23.499c3.766 0 6.825-3.07 6.825-6.856.002-3.784-3.056-6.853-6.823-6.853-1.062 0-2.039.217-2.875.636a1.25 1.25 0 0 1-1.796-.93c-.682-4.501-4.585-7.887-9.179-7.887Zm12.244-9.685-.165.021c-4.126.572-7.43 3.74-8.132 7.846a11.833 11.833 0 0 1 7.308 7.605l.068.231.105-.03a9.287 9.287 0 0 1 2.064-.3l.358-.007a9.26 9.26 0 0 1 5.353 1.694l-.154.112c2.17-1.541 3.598-3.862 3.95-6.452l.01-.084-.176-.019c-5.514-.672-9.89-4.994-10.57-10.45l-.019-.167ZM26.744 45.503a1.25 1.25 0 0 1 2.292.99l-.05.118-1.32 2.667h3.294c.886 0 1.478.89 1.168 1.695l-.048.11-2.21 4.471a1.25 1.25 0 0 1-2.292-.99l.05-.118 1.319-2.668h-3.293a1.25 1.25 0 0 1-1.169-1.694l.048-.11 2.211-4.471Z"
      })
    ], -1)
  ]));
}
const _ = /* @__PURE__ */ o(n, [["render", a]]);
export {
  _ as default
};
